// Every measurement in this app — Passport included — is stored internally
// in centimetres (matching the D1 schema's convention: "min/max are stored
// in centimetres... see SizeChart.unit for provenance"). These helpers only
// affect what the user types/sees; the stored value never changes shape.

const CM_PER_INCH = 2.54;

export function cmToInches(cm: number): number {
  return cm / CM_PER_INCH;
}

export function inchesToCm(inches: number): number {
  return inches * CM_PER_INCH;
}

/** Rounds to 1 decimal place — matches the precision already used for fit deltas elsewhere. */
export function round1(n: number): number {
  return Math.round(n * 10) / 10;
}

/** Converts a stored cm value to the given display unit, rounded for display. */
export function cmToDisplayUnit(cm: number, unit: 'cm' | 'in'): number {
  return unit === 'in' ? round1(cmToInches(cm)) : round1(cm);
}

/** Converts a user-entered value in the given display unit back to cm for storage. */
export function displayUnitToCm(value: number, unit: 'cm' | 'in'): number {
  return unit === 'in' ? round1(inchesToCm(value)) : round1(value);
}

export function formatMeasurement(cm: number | undefined | null, unit: 'cm' | 'in'): string {
  if (cm === undefined || cm === null) return 'Not set';
  const value = cmToDisplayUnit(cm, unit);
  return `${value} ${unit}`;
}
